import { Set } from 'immutable';
import { useHybridTournamentsPush } from './useHybridTournamentsPush';
import { useChannelStatusPush } from '../channelStatus/hooks';

export function useTurboLivePush(tournamentIds: Set<string>) {
    useHybridTournamentsPush(tournamentIds);
    useChannelStatusPush();
}
